import React, { useEffect, useMemo, useState } from 'react';

import { Tooltip, Select } from 'antd';
import { Link } from 'react-router-dom';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { FormItem, FormLabel } from 'src/pages/observers/components/styles';
import {
	useGetWhatsappGroupsQuery
} from 'src/redux/services/centralApi';
import type {
	IWhatsappGroupSelectComponent
} from 'src/pages/observers/components/WhatsAppGroupsSelect/types';

export default function WhatsappGroupSelect(
	{
		defaultWhatsappGroup,
		onWhatsappGroupChange,
	}: IWhatsappGroupSelectComponent
) {
	const {
		data: whatsappGroupsData,
		isLoading: isLoadingWhatsappGroups,
	} = useGetWhatsappGroupsQuery();

	const [ selectedGroups, setSelectedGroups, ] = useState<string[]>([]);

	const groupsWithPermission = useMemo(() => {
		if (!whatsappGroupsData) return [];
		return whatsappGroupsData.map((el) => ({
			label: el.name,
			value: el.groupId,
		}));
	}, [ whatsappGroupsData, ]);

	useEffect(() => {
		if (defaultWhatsappGroup) {
			setSelectedGroups(defaultWhatsappGroup);
		}
	}, [ defaultWhatsappGroup, ]);

	useEffect(() => {
		onWhatsappGroupChange && onWhatsappGroupChange(selectedGroups);
	}, [ selectedGroups, ]);

	return (
		<FormItem>
			<FormLabel>
				* Grupos de whatsapp a serem notificados:
				<Tooltip
					title={
						groupsWithPermission.length === 0 ? (
							<>
								{'Configure um novo grupo de whatsapp '}
								<Link
									to={`${process.env.REACT_APP_PUBLIC_URL}/severidade/adicionar`}
								>
									aqui
								</Link>{' '}
								com pelo menos um(1) usuário com uma permissão
								do observadorpara ter acesso a essa funcionalidade.
							</>
						) : (
							'Selecione os grupos de whatsapp que serão ' +
							'notificados. *Obs: Pelo menos um membro do ' +
							'grupo deve possuir uma mesma permissão do ' +
							'observador.'
						)
					}
				>
					<QuestionCircleOutlined
						style={{ color: 'rgba(0,0,0,0.45)', cursor: 'help', }}
					/>
				</Tooltip>
			</FormLabel>
			<Select
				mode='multiple'
				placeholder='Grupos'
				value={selectedGroups}
				onChange={(value) => setSelectedGroups(value)}
				options={groupsWithPermission}
				loading={isLoadingWhatsappGroups}
				disabled={groupsWithPermission.length === 0}
			/>
		</FormItem>
	);
}
